var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { HasSubscriptions } from '../components/has-subscriptions';
import { PreferencesService } from './preferences.service';
import { CommunicationService } from './communication.service';
import { TranslateService } from '@ngx-translate/core';
import { AnalyticsService } from './analytics/analytics.service';
import { NOTIFICATION_CHECKBOX_VALUE, NOTIFICATION_ENABLED_OFFMARKET } from '../classes/analytics-tags';
var SaveSearchService = /** @class */ (function (_super) {
    __extends(SaveSearchService, _super);
    function SaveSearchService(_preferencesService, _communicationService, _translateService, _analyticsService) {
        var _this = _super.call(this) || this;
        _this._preferencesService = _preferencesService;
        _this._communicationService = _communicationService;
        _this._translateService = _translateService;
        _this._analyticsService = _analyticsService;
        return _this;
    }
    SaveSearchService.prototype.saveSearch = function (name, notification, listing) {
        var _this = this;
        if (listing == null) {
            this.addSavedSearch(name, notification).then(function (s) {
                _this.saveSearchedCompleted(s);
            });
        }
        else {
            this.addSavedSearchOffMarket(name, notification, listing).then(function (s) {
                _this.saveSearchedCompleted(s, listing);
            });
        }
    };
    SaveSearchService.prototype.addSavedSearch = function (name, notification, index) {
        if (index === void 0) { index = -1; }
        return this._preferencesService.addNewSavedSearch(name, notification, index);
    };
    SaveSearchService.prototype.addSavedSearchOffMarket = function (name, notification, listing, index) {
        if (index === void 0) { index = -1; }
        return this._preferencesService.addNewSavedSearch(name, notification, index, listing);
    };
    SaveSearchService.prototype.saveSearchedCompleted = function (s, listing) {
        this._communicationService.selectedSaveSearch.next(s);
        this._communicationService.notifications.bottomNotification.next(this._translateService.instant('actions.add-saved-search', { x: s.name }));
        this.emitTrackingEvents(s, listing);
    };
    SaveSearchService.prototype.emitTrackingEvents = function (s, listing) {
        if (listing && listing.isOffMarket) {
            this._analyticsService.eventTrack(NOTIFICATION_ENABLED_OFFMARKET, s.notificationsEnabled);
        }
        else {
            this._analyticsService.eventTrack(NOTIFICATION_CHECKBOX_VALUE, s.notificationsEnabled);
        }
    };
    return SaveSearchService;
}(HasSubscriptions));
export { SaveSearchService };
